import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["aria-disabled", "onClick"]

import { EllipsisHorizontalIcon, PlusIcon } from '@heroicons/vue/20/solid'
import { onBeforeUnmount, ref, watch } from 'vue'

import { useToast } from '@/composables/useToast'
import api from '@/store/api'


export default {
  __name: 'CustomerActionsMenu',
  props: {
  conversationUserPairId: { type: String, required: true },
  canCreateOrders: { type: Boolean, default: false }
},
  emits: ['new-order'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const { showToast } = useToast()
const root = ref(null)
const agents = ref([])
const open = ref(false)
const busy = ref(false)

const base = () => `conversation_user_pairs/${props.conversationUserPairId}`

const closeOnOutsidePress = event => {
  if (!root.value?.contains(event.target)) open.value = false
}

const closeOnEscape = event => {
  if (event.key === 'Escape') open.value = false
}

const listenForDismiss = listening => {
  const method = listening ? 'addEventListener' : 'removeEventListener'
  document[method]('pointerdown', closeOnOutsidePress, true)
  document[method]('keydown', closeOnEscape)
}

const newOrder = () => {
  open.value = false
  emit('new-order')
}

async function load() {
  const id = props.conversationUserPairId
  agents.value = []
  open.value = false
  try {
    const res = await api.call('GET', `conversation_user_pairs/${id}/triggerable_agents`, {}, { receive: false })
    if (id === props.conversationUserPairId) agents.value = res?.data?.data || []
  } catch (e) {
    if (id !== props.conversationUserPairId) return
    agents.value = []
    throw e
  }
}

async function trigger(agent) {
  if (busy.value) return
  busy.value = true
  open.value = false
  try {
    await api.call('POST', `${base()}/agent_trigger`, { agent_id: agent.agent_id }, { receive: false })
    showToast(`${agent.label} started for this customer.`, { type: 'success' })
  } catch (e) {
    const reason = e?.response?.data?.error || 'Could not start that agent.'
    showToast(reason, { type: 'error' })
  } finally {
    busy.value = false
  }
}

watch(() => props.conversationUserPairId, load, { immediate: true })
watch(open, listenForDismiss)
onBeforeUnmount(() => listenForDismiss(false))

return (_ctx, _cache) => {
  const _directive_tippy = _resolveDirective("tippy")

  return (__props.canCreateOrders || agents.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "root",
        ref: root,
        class: "relative inline-block"
      }, [
        _createElementVNode("button", {
          type: "button",
          "data-test": "more-actions",
          title: "More actions",
          "aria-label": "More actions",
          "aria-haspopup": "menu",
          "aria-expanded": open.value.toString(),
          class: "inline-flex items-center rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-gray-700 hover:bg-gray-50",
          onClick: _cache[0] || (_cache[0] = $event => (open.value = !open.value))
        }, [
          _createVNode(_unref(EllipsisHorizontalIcon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          })
        ], 8, _hoisted_1),
        (open.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-test": "actions-menu",
              class: "absolute right-0 z-20 mt-1 w-64 rounded-md border border-gray-200 bg-white py-1 shadow-lg",
              onMouseleave: _cache[1] || (_cache[1] = $event => (open.value = false))
            }, [
              (__props.canCreateOrders)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    "data-test": "new-order",
                    class: "flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-800 hover:bg-gray-50",
                    onClick: newOrder
                  }, [
                    _createVNode(_unref(PlusIcon), {
                      class: "h-4 w-4 text-gray-500",
                      "aria-hidden": "true"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode(" New order ", -1))
                  ]))
                : _createCommentVNode("", true),
              (agents.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      "data-test": "agent-menu-title",
                      class: _normalizeClass(["px-3 pb-1 pt-2 text-[10.5px] font-medium uppercase tracking-wider text-gray-500", __props.canCreateOrders && 'mt-1 border-t border-gray-100'])
                    }, " Run an agent ", 2),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agents.value, (agent) => {
                        return _withDirectives((_openBlock(), _createElementBlock("li", {
                          key: agent.agent_id,
                          "data-test": "agent-option",
                          "aria-disabled": (!agent.eligible).toString(),
                          class: _normalizeClass(["px-3 py-2 text-sm", 
              agent.eligible ? 'cursor-pointer text-gray-800 hover:bg-gray-50' : 'cursor-not-allowed text-gray-400'
            ]),
                          onClick: $event => (agent.eligible && trigger(agent))
                        }, [
                          _createTextVNode(_toDisplayString(agent.label), 1)
                        ], 10, _hoisted_2)), [
                          [_directive_tippy, agent.eligible ? null : { content: agent.reason || 'Not available for this customer.' }]
                        ])
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}
}

}